export const DenimInterestPages = {
  INTEREST: 'interest',
  SIZE: 'size',
  SUCCESS: 'success',
};
